import { Grid } from "antd";

// md (768px) is the desktop/mobile breakpoint used across the new UI.
export const useIsMobile = (): boolean => {
  const screens = Grid.useBreakpoint();
  return !screens.md;
};
